import React from 'react';
import { BellIcon, CheckIcon, MailIcon, MessageSquareIcon } from 'lucide-react';
import { profile } from '../../data/profil';
import { useRequests, type NotifyChannel } from '../../contexts/RequestsContext';
type Channel = NotifyChannel;
const channels: {
  id: Channel;
  label: string;
  Icon: typeof MailIcon;
}[] = [{
  id: 'courriel',
  label: 'Par courriel',
  Icon: MailIcon
}, {
  id: 'sms',
  label: 'Par SMS',
  Icon: MessageSquareIcon
}];
interface NotifyFollowUpProps {
  /** Inert once the conversation has moved on. */
  live: boolean;
  /** Requête suivie : le choix est partagé entre ATNA et la fiche de détail. */
  requestId: string;
}

/**
 * Proposition d'ATNA, juste après le dépôt : chaque canal s'active (ou se désactive) d'un clic,
 * sans étape de confirmation.
 */
export function NotifyFollowUp({
  live,
  requestId
}: NotifyFollowUpProps) {
  const {
    notifyChannels,
    toggleNotifyChannel
  } = useRequests();
  const selected = notifyChannels[requestId] ?? [];
  const toggle = (channel: Channel) => toggleNotifyChannel(requestId, channel);
  return <div className="mt-5 rounded-2xl bg-ville-sand p-4" data-id="element-1241" data-mp="1qjpa68tgr5hr">
      <p id="suivi-requete-question" className="flex items-center gap-2 text-[15px] font-bold text-ville-navy" data-id="element-1242" data-mp="1llnpxkkax04p">
        <BellIcon className="h-4 w-4 text-ville-indigo" aria-hidden="true" data-id="element-1243" data-mp="1godwlttsk4bl" />
        Voulez-vous être avisée de l’avancement de votre requête ?
      </p>
      <div role="group" aria-labelledby="suivi-requete-question" className="mt-3 flex flex-wrap gap-2" data-id="element-1244" data-mp="29c095rkzyjal">
        {channels.map(({
        id,
        label,
        Icon
      }) => {
        const active = selected.includes(id);
        return <button key={id} type="button" aria-pressed={active} disabled={!live} onClick={() => toggle(id)} title={id === 'courriel' ? profile.email : profile.phone} className={`inline-flex items-center gap-2 rounded-full border px-4 py-2.5 text-sm font-semibold transition-colors duration-150 ease-ville focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo disabled:cursor-default ${active ? 'border-ville-indigo bg-ville-indigo-soft text-ville-indigo' : 'border-slate-200 bg-white text-ville-navy enabled:hover:border-ville-indigo enabled:hover:bg-ville-indigo-soft enabled:hover:text-ville-indigo'}`} data-id="element-1245" data-mp="1zloupb3osrpg">
              {active ? <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-1246" data-mp="2n80qrmqs11j" /> : <Icon className="h-4 w-4" aria-hidden="true" data-id="element-1247" data-mp="6pmeixbk0aly" />}
              {label}
            </button>;
      })}
      </div>
    </div>;
}